<template>
    <div
        v-if="Object.keys(translation).length > 0"
        class="Background"
        :class="{
            'Background--desktop': !isMobile,
            'Background--mobile': isMobile,
            'Background--home': $route.path === '/',
            'Background--assessment': $route.path === '/vessel-specific-assessment',
            'Background--results' : $route.path === '/calculate_results' || $route.path === '/find_results'
    }">
        <hempel-header/>
        <div
            class="ContentWrapper"
            :class="{
                'ContentWrapper--results': !isMobile && ($route.path === '/calculate_results' || $route.path === '/find_results'),
                'ContentWrapper--assessment': $route.path === '/vessel-specific-assessment'
            }"
        >
            <router-view
                class="RouteView"
                :class="{
                    'RouteView--results': !isMobile && ($route.path === '/calculate_results' || $route.path === '/find_results'),
                    'RouteView--assessment': $route.path === '/vessel-specific-assessment'
                }"
            />
            <hempel-footer/>
            <hempel-overlay
                :recommendation="recommendation"
                :feedback="feedback"/>
        </div>
        <!--        <div-->
        <!--            v-if="!isMobile && ($route.path ==='/find' || $route.path === '/calculate')"-->
        <!--            class="Gradients"/>-->
    </div>
</template>
<script>
import HempelHeader from '@/components/shared/header/Header'
import HempelFooter from '@/components/shared/footer/Footer'
import HempelOverlay from '@/components/shared/overlay/Overlay'

export default {
    data() {
        return {
            transitionName: ''
        }
    },
    components: {
        HempelHeader,
        HempelFooter,
        HempelOverlay
    },
    watch: {
        '$route.query.lang': function(language) {
            const normalizedLanguage = this.normalizeLanguage(language)
            const resolvedLanguage = this.resolveLanguage(language)

            if (!language || !normalizedLanguage) {
                this.applyLanguage(this.detectedLanguage || resolvedLanguage, {
                    updateUrl: true
                })
                return
            }

            if (resolvedLanguage !== this.detectedLanguage) {
                this.applyLanguage(resolvedLanguage)
            }
        },
        $route(to, from) {
            const fromHome = to.path.split('/')[1].length
            const toHome = from.path.split('/')[1].length
            const toDepth = to.path.split('_').length
            const fromDepth = from.path.split('_').length

            toHome > fromHome
                ? (this.transitionName = 'slide-down')
                : (this.transitionName = 'slide-up')
            toDepth > fromDepth
                ? (this.transitionName = 'slide-up')
                : (this.transitionName = 'slide-down')
        }
    },
    created() {
        const initialLanguage = this.$route.query.lang ||
            (window.navigator && window.navigator.language)

        this.setLanguage(initialLanguage, { updateUrl: true })
    },
    mounted() {
        this.setCurrentCoordinates()
    }
}
</script>
